export function ActiveBadge(): JSX.Element {
    return (
        <div className="text-lime-700 bg-lime-100 text-xs rounded-md flex items-center gap-1 w-fit py-1 px-1.5">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <path d="M21.801 10A10 10 0 1 1 17 3.335" />
                <path d="m9 11 3 3L22 4" />
            </svg>
            <label>Activated</label>
        </div>
    );
}

export function PendingDeactivationBadge(): JSX.Element {
    return (
        <div className="text-gray-700 bg-gray-100 text-xs rounded-md flex items-center gap-1 w-fit py-1 px-1.5">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <circle cx="12" cy="12" r="10" />
                <polyline points="12 6 12 12 16 14" />
            </svg>
            <label>Pending Deactivation</label>
        </div>
    );
}

export default PendingDeactivationBadge;
